import styled from "styled-components";

export const Section = styled.section`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
`;

export const Title = styled.h2`
  margin: 0 0 12px 0;
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
`;

export const Container = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
`;
